const TextModuleTypes = {
  DELIVERY_NOTE: 'deliveryNote',
  ORDER: 'order',
  INVOICE: 'invoice',
  RECURRING_INVOICE: 'recurringInvoice',
  OFFER: 'offer',
  CANCELLATION: 'cancellation',
  CREDIT_NOTE: 'creditNote',
  PAYMENT_REMINDER: 'paymentReminder',
  FIRST_REMINDER: 'firstReminder',
  SECOND_REMINDER: 'secondReminder',
  LAST_REMINDER: 'lastReminder',
  MANUAL_CREDIT_NOTE: 'manualCreditNote',
  LETTER: 'letter',
  PURCHASE: 'purchase',
  PARTIAL_INVOICE: 'partialInvoice',
  DIRECT_DEBIT_MANDATE_ACTIVATED: 'directDebitMandateActivated',
  DIRECT_DEBIT_MANDATE_PENDING: 'directDebitMandatePending',
  DIRECT_DEBIT_MANDATE_CANCELLED: 'directDebitMandateCancelled',
  DIRECT_DEBIT_PRE_NOTIFICATION: 'directDebitPreNotification',
  DIRECT_DEBIT_MANDATE_CREDITOR_IDENTIFIER_UPDATED: 'directDebitMandateCreditorIdentifierUpdated',
}

export default Object.freeze(TextModuleTypes)
